import React from 'react';
import { _t } from 'utils';
import { MONGODB_EDITIONS } from '../constant';

export const getMinDateTimeForBackup = ({
  backup,
  byCreationTime,
  retentionDays = 7,
}) => {
  // check minDateTime for backup
  const minDateTimeFromNow = new Date();
  minDateTimeFromNow.setDate(minDateTimeFromNow.getDate() - retentionDays);
  let minDateTimeFromItem = backup && new Date(backup.properties.earliestRecoveryTargetTime || backup.metadata.createdDate);

  if (backup && byCreationTime) {
    minDateTimeFromItem = new Date(backup.properties.creationTime);
    minDateTimeFromItem.setDate(minDateTimeFromItem.getDate() - retentionDays);
    return minDateTimeFromItem;
  }
  return minDateTimeFromItem && minDateTimeFromNow < minDateTimeFromItem ? minDateTimeFromItem : minDateTimeFromNow;
};

export const generateTemplateListItem = ({ id, properties: template }) => (
  <div style={{ paddingTop: 5, paddingBottom: 5 }}>
    <div style={{ fontWeight: 600 }}>{template.name}</div>
    <div className="dbaas-template-item" key={id}>
      <div style={{ width: 150 }}>
        <div>{`${_t('DATABASES.FORM_FIELDS.RAM.TITLE')}:`}</div>
        <div>{template.ram / 1024}</div>
      </div>
      <div style={{ width: 80 }}>
        <div>{`${_t('DATABASES.FORM_FIELDS.VCORES.TITLE')}:`}</div>
        <div>{template.cores}</div>
      </div>
      <div style={{ width: 177 }}>
        <div>{`${_t('DATABASES.FORM_FIELDS.STORAGE_SIZE.TITLE')}:`}</div>
        <div>{`${template.storageSize} GB`}</div>
      </div>
    </div>
  </div>
);

export const sortAndGenerateTemplates = (templates = [], model, quota, values) => {
  const {
    maxCores,
    maxRam,
    maxStorage,
  } = quota;
  const {
    instances,
    edition,
    shards,
  } = model;

  const currentTemplate = values && templates.find((e) => e.id === values.properties.templateID);
  const currentTemplateStorage = currentTemplate?.properties?.storageSize || 0;

  const currentMaxCores = Math.floor(maxCores / (instances * (shards || 1)));
  const currentMaxRam = Math.floor(maxRam / (instances * (shards || 1))) * 1024;
  const currentMaxStorage = Math.floor(maxStorage / (instances * (shards || 1)));

  const editions = [MONGODB_EDITIONS.BUSINESS];

  if ((!values || currentTemplate?.properties?.edition !== MONGODB_EDITIONS.BUSINESS) && instances === 1) {
    editions.push(MONGODB_EDITIONS.PLAYGROUND);
  }

  return templates
    .filter((item) => (!edition || edition === item.properties?.edition) && editions.includes(item.properties?.edition))
    .map((item) => {
      item.disabled = !(item.properties?.storageSize >= currentTemplateStorage
      && item.properties?.cores <= currentMaxCores && item.properties?.ram <= currentMaxRam && item.properties?.storageSize <= currentMaxStorage);
      return item;
    })
    .sort((a, b) => a.properties?.ram - b.properties?.ram)
    .map((item) => ([item.id, generateTemplateListItem(item), '', item.disabled, item.disabled ? _t('COMMON.TEXTS.NOT_ENOUGH_RESOURCES') : '']));
};

export const getPossibleInstancesOptionsForTemplate = ({
  templates,
  instanceOptions,
  quota,
  model,
}) => {
  const { maxCores, maxRam, maxStorage } = quota;

  const currentTemplate = model && templates.find((e) => e.id === model.templateID);
  // const currentTemplateStorage = currentTemplate?.storageSize || 0;
  if (!currentTemplate) return instanceOptions;
  const { shards } = model;
  return instanceOptions.filter((instanceValue) => {
    const cores = currentTemplate.properties?.cores * instanceValue * (shards || 1);
    const ram = (currentTemplate.properties?.ram / 1024) * instanceValue * (shards || 1);
    const storage = currentTemplate.properties?.storageSize * instanceValue * (shards || 1);

    return maxCores >= cores && maxRam >= ram && maxStorage >= storage;
  });
};

export const getMongoDBRoleOptions = (isEnterpriseCluster) => [
  {
    value: 'read',
    disable: false,
  },
  {
    value: 'readWrite',
    disable: false,
  },
  {
    value: 'dbAdmin',
    disable: false,
  },
  ...(
    !isEnterpriseCluster ? [] : [
      {
        value: 'enableSharding',
        defaultDatabase: 'admin',
        disable: true,
      },
    ]
  ),
  {
    value: 'readAnyDatabase',
    defaultDatabase: 'admin',
    disable: true,
  },
  {
    value: 'readWriteAnyDatabase',
    defaultDatabase: 'admin',
    disable: true,
  },
  {
    value: 'clusterMonitor',
    defaultDatabase: 'admin',
    disable: true,
  },
  {
    value: 'dbAdminAnyDatabase',
    defaultDatabase: 'admin',
    disable: true,
  },
];

export const checkFreeOfCharge = ({
  databaseClusters,
  templates,
  values,
}) => {
  const currentTemplate = values && templates.find((e) => e.id === values.properties?.templateID);
  if (!currentTemplate || currentTemplate.properties.edition !== MONGODB_EDITIONS.PLAYGROUND) {
    return false;
  }

  const clusters = databaseClusters.map((cluster) => {
    if (cluster.id === values.id) {
      return values;
    }
    return cluster;
  });

  const playgroundClusters = clusters.filter(({ properties }) => {
    const template = templates.find(({ id }) => id === properties.templateID);
    return template?.properties?.edition === MONGODB_EDITIONS.PLAYGROUND;
  });

  if (playgroundClusters.length === 1) {
    return true;
  }

  if (playgroundClusters.length > 1) {
    const sortedClusters = playgroundClusters.sort((a, b) => new Date(a.metadata.createdDate) - new Date(b.metadata.createdDate));
    return values.id === sortedClusters[0].id;
  }

  return false;
};
